import Android from './logo/android';
import Apple from './logo/apple';
import newrelic from './logo/newrelic';

export default {
  apple: Apple,
  android: Android,
  newrelic,
};
